import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Centrifugal from 'features/processFlowDiagrams/svg/pumps-din/centrifugal.svg?react'
import Diaphragm from 'features/processFlowDiagrams/svg/pumps-din/diaphragm.svg?react'
import EccentricWorm from 'features/processFlowDiagrams/svg/pumps-din/eccentric-worm.svg?react'
import Electromagnetic from 'features/processFlowDiagrams/svg/pumps-din/electromagnetic.svg?react'
import Gear from 'features/processFlowDiagrams/svg/pumps-din/gear.svg?react'
import Hydraulic from 'features/processFlowDiagrams/svg/pumps-din/hydraulic.svg?react'
import LiquidJet from 'features/processFlowDiagrams/svg/pumps-din/liquid-jet.svg?react'
import Reciprocating from 'features/processFlowDiagrams/svg/pumps-din/reciprocating.svg?react'
import RotaryPiston from 'features/processFlowDiagrams/svg/pumps-din/rotary-piston.svg?react'
import Screw from 'features/processFlowDiagrams/svg/pumps-din/screw.svg?react'
import React from 'react'

export const PID_PUMPS_DIN_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'centrifugal',
    name: 'Centrifugal',
    category: 'pumps-din',
    svgContent: <Centrifugal />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'diaphragm',
    name: 'Diaphragm',
    category: 'pumps-din',
    svgContent: <Diaphragm />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'eccentric-worm',
    name: 'Eccentric Worm',
    category: 'pumps-din',
    svgContent: <EccentricWorm />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'electromagnetic',
    name: 'Electromagnetic',
    category: 'pumps-din',
    svgContent: <Electromagnetic />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'gear',
    name: 'Gear',
    category: 'pumps-din',
    svgContent: <Gear />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'hydraulic',
    name: 'Hydraulic',
    category: 'pumps-din',
    svgContent: <Hydraulic />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'liquid-jet',
    name: 'Liquid Jet',
    category: 'pumps-din',
    svgContent: <LiquidJet />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'reciprocating',
    name: 'Reciprocating',
    category: 'pumps-din',
    svgContent: <Reciprocating />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'rotary-piston',
    name: 'Rotary Piston',
    category: 'pumps-din',
    svgContent: <RotaryPiston />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'screw',
    name: 'Screw',
    category: 'pumps-din',
    svgContent: <Screw />,
    viewBox: '0 0 100 100',
  },
]
